// Teinte stable dérivée d'une chaîne (même logique que les avatars de la
// distribution) → couleurs cohérentes dans tout le site.
export function hueFromString(str) {
  const s = str || '';
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) % 360;
  return h;
}

export function pastel(str) {
  return `hsl(${hueFromString(str)} 55% 72%)`;
}
